import { render, staticRenderFns } from "./prescriptionOne.vue?vue&type=template&id=1c93769c&scoped=true&"
import script from "./prescriptionOne.vue?vue&type=script&lang=ts&"
export * from "./prescriptionOne.vue?vue&type=script&lang=ts&"
import style0 from "./prescriptionOne.vue?vue&type=style&index=0&id=1c93769c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c93769c",
  null
  
)

export default component.exports